var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.32636",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "client-types": "static-1.374",
      "codemirror-dlb": "static-1.53612",
      "collaboration-sidebar": "static-1.52824",
      "ContentComponents": "static-2.66442",
      "ContentData": "static-1.63561",
      "ContentEditorUI": "static-2.72056",
      "ContentUtils": "static-1.63485",
      "customer-agent-discovery-components-lib": "static-1.796",
      "data-fetching-client": "static-1.8462",
      "editor-components": "static-1.11873",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.34506",
      "foundations-assets": "static-1.3773",
      "foundations-components": "static-1.6056",
      "head-dlb": "static-1.4043",
      "hs-test-utils": "static-1.6857",
      "hub-http": "static-1.4807",
      "hub-http-shared-msw-handlers": "static-1.7125",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10348",
      "I18n": "static-7.1391",
      "InpageEditorUI": "static-1.80498",
      "jasmine-immutable": "static-1.1813",
      "jasmine-runner": "static-1.5251",
      "layout-dnd-utils": "static-1.9756",
      "personalization-lib": "static-1.1916",
      "quartz": "static-1.5604",
      "react-dlb": "static-1.53",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4360",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11396",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4364",
      "ui-components-test-utils": "static-1.4486",
      "ui-images": "static-2.851",
      "ui-memberships-settings-lib": "static-1.28850",
      "video-components-external": "static-1.6130",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.5304",
      "apollo-stack-hubspot": "static-3.43",
      "asset-actions-lib": "static-1.40273",
      "atom": "static-1.4051",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.22585",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.6352",
      "content-management-actions-lib": "static-1.22853",
      "content-management-data-lib": "static-1.3927",
      "content-management-restrictions-lib": "static-1.3654",
      "copilot-plugins": "static-1.6597",
      "copilot-toolkit": "static-1.6624",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.503",
      "cta-picker": "static-1.31829",
      "customer-data-objects": "static-1.6472",
      "customer-data-objects-ui-components": "static-1.11742",
      "customer-data-properties": "static-1.46112",
      "customer-data-property-utils": "static-1.6786",
      "customer-data-reference-ui-components": "static-1.11852",
      "customer-data-ui-utilities": "static-1.8571",
      "data-token-picker": "static-1.14194",
      "data-token-views": "static-1.14175",
      "error-messaging-js": "static-1.4144",
      "feedback-loader": "static-1.26635",
      "file-manager-components": "static-1.18865",
      "FileManagerCore": "static-1.34365",
      "FormsCommonComponents": "static-1.81325",
      "foundations-theming": "static-1.3169",
      "fuzzy": "static-1.8",
      "growth-onboarding-confetti": "static-1.1948",
      "growth-payments-core": "static-1.21350",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4374",
      "hub-http-contrib": "static-1.2014",
      "hubspot-url-utils": "static-1.3063",
      "HubStyle": "static-2.10656",
      "icons": "static-2.592",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.10016",
      "integrations-lib": "static-1.10781",
      "interframe": "static-3.3647",
      "laboratory-lib": "static-3.6100",
      "layout-data-lib": "static-1.8081",
      "media-bridge-lib": "static-1.16792",
      "nav-meta": "static-1.25610",
      "object-builder-ui-client": "static-1.42598",
      "onboarding-scopes": "static-1.5409",
      "onboarding-tours": "static-1.14459",
      "onboarding-tours-client": "static-1.3347",
      "outpost": "static-1.3205",
      "page-lib": "static-1.16624",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.18953",
      "payments-post-enroll-local-storage-lib": "static-1.3947",
      "pictos": "static-7.160",
      "PortalIdParser": "static-2.284",
      "products-ui-components": "static-1.35676",
      "property-translator": "static-1.4246",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.4818",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9094",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.47",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.15430",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.50853",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.74",
      "redux": "static-4.16",
      "redux-request-state": "static-1.9431",
      "reference-resolvers": "static-1.7008",
      "reference-resolvers-lite": "static-1.6838",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.17525",
      "rpc-client-utils": "static-1.3561",
      "sanitize": "static-1.3233",
      "sanitize-text": "static-1.7021",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9055",
      "SharedI18nStrings": "static-1.162",
      "SharedLegalStrings": "static-1.1310",
      "simple-menus-core": "static-1.13610",
      "simple-menus-lib": "static-1.15127",
      "smart-content-lib": "static-1.38367",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.461",
      "superstore": "static-1.3621",
      "theme-previewer-lib": "static-1.48456",
      "tinymce-config": "static-2.49979",
      "tinymce-copilot": "static-1.12047",
      "tinymce-data": "static-1.36064",
      "tinymce-plugins": "static-1.53093",
      "tinymce-themes": "static-1.51949",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.8157",
      "ui-addon-emoji-picker": "static-1.8797",
      "ui-addon-form-validation": "static-1.9868",
      "ui-addon-i18n": "static-1.9770",
      "ui-addon-iframeable": "static-1.7740",
      "ui-addon-opt": "static-4.7479",
      "ui-addon-sales-email": "static-1.4061",
      "ui-addon-upgrades": "static-9.16086",
      "ui-business-units-lib": "static-1.7729",
      "ui-gdpr-components": "static-1.9091",
      "ui-product-approvals": "static-1.24018",
      "ui-shepherd-react": "static-3.8913",
      "ui-suspension-banners-lib": "static-1.5269",
      "UIComponents": "static-3.7295",
      "underscore": "static-1.8",
      "urlinator": "static-1.3399",
      "usage-tracker": "static-1.6323",
      "usage-tracker-core": "static-1.6173",
      "user-context": "static-1.4024",
      "video-embed": "static-1.30622",
      "web-interactives-components": "static-1.11588",
      "web-interactives-data": "static-1.11589",
      "wootric-nps": "static-1.5773",
      "xray-recommendation-lib": "static-1.6046",
      "codemirror": "static-5.72",
      "react-codemirror": "static-1.9460",
      "enviro": "static-4.306",
      "hs-promise-rejection-tracking": "static-1.4356",
      "raven-hubspot": "static-1.5125",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.8459",
      "bend-plugin-trellis-migration": "static-1.2491",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.8674",
      "chatspot-core": "static-1.15867",
      "chatspot-widget-iframe": "static-1.15861",
      "framework-data-schema-resolvers": "static-1.5721",
      "frontend-preferences-client": "static-1.6718",
      "graphql": "static-1.59",
      "magpie-lib": "static-1.4516",
      "magpie-types": "static-1.3976",
      "quartz-core": "static-1.4823",
      "simple-logging-lib": "static-1.1886",
      "ts-schema": "static-1.3170",
      "cms-field-types": "static-1.3638",
      "content-embed-lib": "static-1.6203",
      "ExportDialog": "static-6.9232",
      "forms-utils-lib": "static-1.10297",
      "integrations-error-boundary-lib": "static-1.8196",
      "payments-embed-points-lib": "static-1.9648",
      "react-dnd-compat": "static-1.3504",
      "usage-tracker-container": "static-1.6313",
      "video-data-lib": "static-1.29781",
      "videoconference-integration-components": "static-1.5017",
      "editor-iframe-lib": "static-1.7155",
      "FireAlarmUi": "static-1.3670",
      "hubspot-apollo-client": "static-1.3674",
      "layout-dnd-components": "static-1.10781",
      "marketing-email-service-types": "static-1.1458",
      "smart-content-core": "static-1.37714",
      "social-composer-lib": "static-1.53645",
      "structured-content-lib": "static-1.20625",
      "timezone-utils": "static-2.4090",
      "ui-active-theme-content-creator-lib": "static-1.32538",
      "ui-addon-video-player": "static-1.7618",
      "ui-asset-management-lib": "static-1.9137",
      "ui-tool-access": "static-1.8904",
      "content-icons-ui": "static-1.1911",
      "react-aria": "static-1.39",
      "FileManagerImages": "static-1.32016",
      "hs-story-utils": "static-1.8238",
      "bend-plugin-foundations-components": "static-1.2325",
      "floating-ui": "static-1.29",
      "foundations-theming-specialty": "static-1.886",
      "framer-motion": "static-1.41",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "HeadJS": "static-2.577",
      "hs-test-utils-bend-plugin": "static-1.1968",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.198",
      "moment-timezone": "static-5.51",
      "NamespacedHubStyle": "static-2.8260",
      "react-dnd-ipeui-backend": "static-1.913",
      "ui-coaching-tips": "static-1.23221",
      "jasmine": "static-4.3192",
      "marketplace-embed": "static-1.16965",
      "quartz-core-utils": "static-1.2471",
      "flux-actions": "static-1.273",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9320",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.3541",
      "apollo-link-hub-http": "static-2.3628",
      "content-media-compositions": "static-2.10521",
      "idb-keyval": "static-1.21",
      "immerable": "static-1.2998",
      "video-components": "static-1.8133",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.2154",
      "sassPrefix": "static-1.131",
      "marketing-platform-lib": "static-1.5538",
      "attribution-lib": "static-1.37922",
      "campaigns-build-lib": "static-1.8318",
      "crm-pipelines-api-client-types": "static-1.3162",
      "reporting-ui-components": "static-2.59239",
      "ai-rendering-library": "static-1.5374",
      "ui-brand-identity-lib": "static-1.9048",
      "avatar-components": "static-1.1287",
      "calling-cross-tab-library": "static-1.18063",
      "calling-lifecycle-messages": "static-1.51882",
      "commerce-products-lib": "static-1.5156",
      "conditional-properties-service-client": "static-1.2955",
      "crm-links": "static-1.4957",
      "crm-message-bus": "static-1.37092",
      "external-options-client-types": "static-1.3119",
      "google-libphonenumber": "static-1.12",
      "inbound-db-meta-service-client": "static-1.2824",
      "inbound-db-properties-service-client": "static-1.2965",
      "inbounddb-objects-service-types": "static-1.3248",
      "pipeline-validation-client-types": "static-1.2918",
      "smart-property-lib": "static-1.1065",
      "react-immutable-render-mixin": "static-1.9",
      "audio-components": "static-1.4509",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.501",
      "forms-ai-lib": "static-1.2301",
      "bend-plugin-foundations-theming": "static-1.1652",
      "commerce-analytics-service-client": "static-1.2556",
      "integrations-tracking-lib": "static-1.4371",
      "native-integrations-shared-strings": "static-1.6686",
      "getting-started-shared-tasks": "static-1.12923",
      "growth-data-modal": "static-1.4074",
      "navigation-components": "static-1.13973",
      "ui-shepherd-tracker": "static-1.6294",
      "ui-universal-auth": "static-1.7646",
      "commerce-tours-lib": "static-1.3689",
      "growth-onboarding-reliability": "static-1.4004",
      "sales-checkout-service-client": "static-1.2568",
      "commerce-shared-components-lib": "static-1.14921",
      "commerce-subscription-lib": "static-1.31737",
      "crm_components": "static-3.86980",
      "crm_data": "static-4.86980",
      "customer-data-filters-ui": "static-1.34178",
      "customer-data-tracking": "static-1.5654",
      "dispatcher": "static-1.113",
      "framework-data-table": "static-2.8752",
      "property-description-translator": "static-1.2699",
      "csstype": "static-1.38",
      "batch-promise": "static-1.438",
      "fast-json-stable-stringify": "static-1.4",
      "commerce-tools-ui-lib": "static-1.6867",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3619",
      "navigation-messaging": "static-1.3300",
      "feature-store-service-types": "static-1.3535",
      "growth-monetization-service-types": "static-1.3542",
      "upgrade-management-service-types": "static-1.3526",
      "getting-started-shared-tasks-store": "static-1.12041",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "framework-builder-read-service-client": "static-1.3092",
      "framework-data-schema-quick-fetch": "static-1.5626",
      "persist-promise": "static-1.2596",
      "hub-http-janus": "static-1.648",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.7123",
      "mobile-manifest-mixins": "static-1.348",
      "platform-navigation-bootstrap": "static-1.11265",
      "payments-enrollment-embed-lib": "static-1.17936",
      "growth-onboarding-feedback-components": "static-1.5299",
      "marketplace-ui-apps-core": "static-1.13088",
      "marketplace-ui-client-types": "static-1.11959",
      "marketplace-ui-common": "static-1.14552",
      "marketplace-ui-details": "static-1.4452",
      "property-management-iframe": "static-1.8519",
      "trellis-ecosystem": "static-1.4753",
      "social-insights-client-types": "static-1.17908",
      "FormUrlGenerator": "static-2.3569",
      "highcharts": "static-8.81",
      "report-customization-components": "static-1.9039",
      "reporting-action-components": "static-1.36584",
      "reporting-data": "static-1.61962",
      "reporting-enablement": "static-1.17450",
      "reporting-snowflake": "static-1.50583",
      "reporting-visualizations": "static-1.54039",
      "customer-data-filters": "static-1.47993",
      "reporting-plugins": "static-1.7065",
      "reporting-reports": "static-1.61645",
      "highlight.js": "static-1.45",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "ui-addon-teams": "static-1.19852",
      "calling-internal-common": "static-1.30083",
      "shared-worker-versioning": "static-1.9924",
      "calling-global-api": "static-1.58205",
      "calling-lifecycle-internal": "static-1.59587",
      "products-iframe-lib": "static-1.3399",
      "products-ui-components-shared-msw-handlers": "static-1.7508",
      "location-customization-utils-lib": "static-1.4256",
      "breeze-intelligence-kit": "static-1.4091",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.7209",
      "fsm": "static-1.2553",
      "policy-lib": "static-1.5629",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.7271",
      "final-form": "static-1.40",
      "universal-page-editor-lib": "static-1.1798",
      "commerce-billing-lib": "static-1.15043",
      "commerce-contract-lib": "static-1.6655",
      "conversations-skeleton-state": "static-1.6233",
      "crm_universal": "static-1.20605",
      "customer-data-content": "static-1.24615",
      "crm_schema": "static-3.87018",
      "customer-data-email": "static-1.15859",
      "customer-data-filters-ui-msw-helpers": "static-1.16611",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.6060",
      "customer-data-rte": "static-1.29242",
      "cv-backend-services": "static-1.1177",
      "growth-onboarding-empty-states": "static-1.4076",
      "hubspot-prosemirror": "static-1.13896",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.44",
      "quotes-client-types": "static-1.32082",
      "platform-infra-nav-components": "static-1.6729",
      "stripe-embedded-components": "static-1.5328",
      "developer-experience-shared-components": "static-1.9020",
      "immutable-less": "static-1.3402",
      "ui-addon-integrations-directory-panel": "static-2.6842",
      "ui-extensibility-client-types": "static-1.3003",
      "ai-settings-ui-library": "static-1.5977",
      "react-window": "static-1.13",
      "ui-addon-react-router-dom": "static-1.8456",
      "ai-studio-lib": "static-1.5950",
      "embedded-academy-lib": "static-1.10388",
      "marketplace-ui-reviews": "static-1.14511",
      "marketplace-ui-tracking": "static-1.8726",
      "property-management-common": "static-1.805",
      "trellis-story-utils": "static-1.3395",
      "dashboard-lib": "static-1.76180",
      "share-with-third-party-component-lib": "static-1.7514",
      "reporting-client-types": "static-1.1932",
      "data-quality-ui-library": "static-1.8384",
      "html-to-image": "static-1.30",
      "reporting-datasets-permissions-lib": "static-1.7964",
      "crm-object-map": "static-1.2076",
      "deep-diff": "static-1.5",
      "campaign-roi-lib": "static-1.3372",
      "calling-error-reporting": "static-1.30089",
      "calling-usage-tracker": "static-1.5342",
      "calling-orchestration-shared-library": "static-1.30352",
      "multi-currency-client-types": "static-1.2809",
      "sales-views-client-types": "static-1.3162",
      "crm-record-cards-service-types": "static-1.2792",
      "storybook-react": "static-1.4",
      "usage-tracker-session-replay": "static-1.4009",
      "utility-belt": "static-1.1408",
      "crm-cards-sdk": "static-1.38425",
      "zustand": "static-1.51",
      "SalesContentIndexUI": "static-3.7186",
      "sequences-lib": "static-1.5999",
      "draft-content-plugins": "static-1.24603",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.19362",
      "knowledge-content-types": "static-1.7755",
      "stripe-connect-js": "static-1.40",
      "apps-service-types": "static-1.2938",
      "oauth-service-types": "static-1.3150",
      "automation-ui-action-features": "static-1.50069",
      "academy-common-lib": "static-1.9848",
      "crm-component-utils": "static-1.34805",
      "redux-actions": "static-3.7",
      "crm-index-visualization-object-layout": "static-1.822",
      "crm-object-search-query-utilities": "static-1.6430",
      "calling-orchestration-schema": "static-1.30577",
      "amplitude-session-replay-browser": "static-1.33",
      "crm-actions": "static-1.4930",
      "crm-fe-perf": "static-1.21852",
      "sales-templates-service-types-lib": "static-1.3205",
      "sequences-client-types-lib": "static-1.5856",
      "ads-client-types": "static-1.17335",
      "app-users-service-types": "static-1.3400",
      "automation-actions-service-types": "static-1.3352",
      "automation-applications-service-types": "static-1.2571",
      "automation-platform-service-types": "static-1.2140",
      "automation-ui-action-fields": "static-1.33374",
      "automation-ui-associations": "static-1.14959",
      "automation-ui-core": "static-2.16285",
      "automation-ui-enrollment": "static-1.51716",
      "automation-ui-flow-core": "static-1.15674",
      "automation-ui-formula-editor": "static-1.11822",
      "automation-ui-i18n": "static-1.15742",
      "automation-ui-permissions": "static-1.14645",
      "automation-ui-references": "static-1.15697",
      "automation-ui-routing": "static-1.15709",
      "automation-ui-source-apps": "static-1.13431",
      "automation-ui-types": "static-1.14349",
      "automation-ui-ubb": "static-1.268",
      "automation-ui-usage-tracking": "static-1.15751",
      "crm-properties-common-lib": "static-1.4517",
      "messaging-editing-lib": "static-1.40989",
      "routing-ui": "static-1.16437",
      "skills-lib": "static-1.25245",
      "task-forms-lib": "static-1.36418",
      "ui-addon-automation-embed": "static-1.12396",
      "usage-based-billing-components-lib": "static-1.4091",
      "academy-service-client": "static-1.2688",
      "card-properties-lib": "static-1.39140",
      "customer-data-properties-shared-msw-handlers": "static-1.6453",
      "crm-association-components-lib": "static-1.5216",
      "messaging-publishing-lib": "static-1.40941",
      "mobile-messaging-management-lib": "static-1.29631",
      "automation-enrollment-service-types": "static-1.2732",
      "data-ops-fullstory": "static-1.4188",
      "workflows-copilot-service-types": "static-1.1519",
      "messaging-types-lib": "static-1.40725",
      "short-messages-app-service-client": "static-1.2933",
      "ably": "static-1.18",
      "ably-hubspot-js": "static-2.3425",
      "conversations-http": "static-1.3650",
      "conversations-internal-schema": "static-1.11499",
      "conversations-message-history": "static-1.9953",
      "conversations-prop-types": "static-1.6267",
      "conversations-async-data": "static-2.6516",
      "conversations-error-reporting": "static-1.7793",
      "conversations-infrastructure": "static-1.7787",
      "conversations-thread-data": "static-1.63108",
      "conversations-thread-view": "static-1.71839",
      "conversations-visibility-tools": "static-1.4604",
      "svh-tickets-lib": "static-1.14182",
      "crm-activity-creator-data": "static-1.41514",
      "customer-data-communicator": "static-1.40515",
      "subscription-experience-data-types": "static-1.11014",
      "customer-data-sidebar": "static-2.41356",
      "enrichment-properties-lib": "static-1.10185",
      "framework-listing-lib": "static-2.22976",
      "industries-core": "static-1.5618",
      "messaging-management-lib": "static-1.12501",
      "calling-cross-tab-messaging": "static-1.18060",
      "conversations-internal-pub-sub": "static-1.14852",
      "conversations-routing-lib": "static-1.6740",
      "call-widget-addon": "static-2.28312",
      "calling-integration-cross-tab": "static-1.17974",
      "calling-integration-help-desk": "static-1.19780",
      "calling-ui-library": "static-1.65505",
      "composer-data": "static-1.25895",
      "conversations-inbox-message-history": "static-1.30321",
      "conversations-platform": "static-1.3339",
      "EmailSignatureEditor": "static-1.20846",
      "zorse-crm-components-lib": "static-1.5860",
      "data-model-commons-lib": "static-1.7454",
      "universal-associations-select": "static-1.9644",
      "crm-display-components": "static-1.20555",
      "crm-legacy-global-containers": "static-1.22645",
      "draft-email-branding-plugin": "static-2.20534",
      "draft-signature-plugin": "static-1.20282",
      "hubspot-prosemirror-plugins": "static-1.13888",
      "integration-settings-components": "static-1.10702",
      "outreach-assistant-email-generation": "static-1.3097",
      "sales-email-signature-service-client": "static-1.2829",
      "card-payment-highlight-lib": "static-1.32207",
      "card-subscription-highlight-lib": "static-1.34160",
      "invoices-highlight-card-lib": "static-1.49784",
      "orders-highlight-card-lib": "static-1.17414",
      "products-highlight-card-lib": "static-1.13441",
      "project-storage": "static-1.3535",
      "quotes-highlight-card-lib": "static-1.65999",
      "crm-source-interpretation-lib": "static-1.4134",
      "customer-data-views-management": "static-1.22430",
      "signup-ui-full-screen-search": "static-1.10224",
      "calling-client-interface": "static-1.70744",
      "calling-integration-sdk-support": "static-1.26200",
      "calling-lifecycle-usage-tracker": "static-1.4979",
      "worker-connection-library": "static-1.12361",
      "share-transcript-modal": "static-1.52755",
      "transcript-sidebar": "static-1.63109",
      "twilio-voice-sdk": "static-1.51",
      "conversations-calling-message": "static-1.55285",
      "signup-constants": "static-1.16368",
      "signup-ui-lego-core": "static-1.18378",
      "viral-links-lib": "static-1.5733",
      "remote-ui": "static-1.40",
      "ui-extensions-remote-renderer": "static-1.12817",
      "accounting-integrations-ui-components": "static-1.4969",
      "invoices-iframe-lib": "static-1.51858",
      "invoices-ui-lib": "static-1.49800",
      "SafeStorage": "static-1.3256",
      "quotes-modal-lib": "static-1.96670",
      "quotes-ui-lib": "static-1.74713",
      "crm-export-dialog": "static-1.5137",
      "crm-index-associations-lib": "static-1.5257",
      "ai-addon-copilot-preview": "static-1.4516",
      "recording-review-components-lib": "static-1.27038",
      "call-summary": "static-1.32897",
      "emoji-regex": "static-1.7",
      "signup-ui-url-generator": "static-2.6908",
      "object-comments-thread-lib": "static-1.6406"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.32636",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "client-types": "/client-types/static-1.374",
      "codemirror-dlb": "/codemirror-dlb/static-1.53612",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.52824",
      "ContentComponents": "/ContentComponents/static-2.66442",
      "ContentData": "/ContentData/static-1.63561",
      "ContentEditorUI": "/ContentEditorUI/static-2.72056",
      "ContentUtils": "/ContentUtils/static-1.63485",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.796",
      "data-fetching-client": "/data-fetching-client/static-1.8462",
      "editor-components": "/editor-components/static-1.11873",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.34506",
      "foundations-assets": "/foundations-assets/static-1.3773",
      "foundations-components": "/foundations-components/static-1.6056",
      "head-dlb": "/head-dlb/static-1.4043",
      "hs-test-utils": "/hs-test-utils/static-1.6857",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7125",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10348",
      "I18n": "/I18n/static-7.1391",
      "InpageEditorUI": "/InpageEditorUI/static-1.80498",
      "jasmine-immutable": "/jasmine-immutable/static-1.1813",
      "jasmine-runner": "/jasmine-runner/static-1.5251",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.9756",
      "personalization-lib": "/personalization-lib/static-1.1916",
      "quartz": "/quartz/static-1.5604",
      "react-dlb": "/react-dlb/static-1.53",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4360",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11396",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4364",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.4486",
      "ui-images": "/ui-images/static-2.851",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.28850",
      "video-components-external": "/video-components-external/static-1.6130",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5304",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "asset-actions-lib": "/asset-actions-lib/static-1.40273",
      "atom": "/atom/static-1.4051",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.22585",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.6352",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.22853",
      "content-management-data-lib": "/content-management-data-lib/static-1.3927",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.3654",
      "copilot-plugins": "/copilot-plugins/static-1.6597",
      "copilot-toolkit": "/copilot-toolkit/static-1.6624",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.503",
      "cta-picker": "/cta-picker/static-1.31829",
      "customer-data-objects": "/customer-data-objects/static-1.6472",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11742",
      "customer-data-properties": "/customer-data-properties/static-1.46112",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.6786",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11852",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8571",
      "data-token-picker": "/data-token-picker/static-1.14194",
      "data-token-views": "/data-token-views/static-1.14175",
      "error-messaging-js": "/error-messaging-js/static-1.4144",
      "feedback-loader": "/feedback-loader/static-1.26635",
      "file-manager-components": "/file-manager-components/static-1.18865",
      "FileManagerCore": "/FileManagerCore/static-1.34365",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.81325",
      "foundations-theming": "/foundations-theming/static-1.3169",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1948",
      "growth-payments-core": "/growth-payments-core/static-1.21350",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4374",
      "hub-http-contrib": "/hub-http-contrib/static-1.2014",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "HubStyle": "/HubStyle/static-2.10656",
      "icons": "/icons/static-2.592",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.10016",
      "integrations-lib": "/integrations-lib/static-1.10781",
      "interframe": "/interframe/static-3.3647",
      "laboratory-lib": "/laboratory-lib/static-3.6100",
      "layout-data-lib": "/layout-data-lib/static-1.8081",
      "media-bridge-lib": "/media-bridge-lib/static-1.16792",
      "nav-meta": "/nav-meta/static-1.25610",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.42598",
      "onboarding-scopes": "/onboarding-scopes/static-1.5409",
      "onboarding-tours": "/onboarding-tours/static-1.14459",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3347",
      "outpost": "/outpost/static-1.3205",
      "page-lib": "/page-lib/static-1.16624",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.18953",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3947",
      "pictos": "/pictos/static-7.160",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "products-ui-components": "/products-ui-components/static-1.35676",
      "property-translator": "/property-translator/static-1.4246",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.4818",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9094",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.47",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.15430",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.50853",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.74",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.9431",
      "reference-resolvers": "/reference-resolvers/static-1.7008",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6838",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.17525",
      "rpc-client-utils": "/rpc-client-utils/static-1.3561",
      "sanitize": "/sanitize/static-1.3233",
      "sanitize-text": "/sanitize-text/static-1.7021",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9055",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1310",
      "simple-menus-core": "/simple-menus-core/static-1.13610",
      "simple-menus-lib": "/simple-menus-lib/static-1.15127",
      "smart-content-lib": "/smart-content-lib/static-1.38367",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.461",
      "superstore": "/superstore/static-1.3621",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.48456",
      "tinymce-config": "/tinymce-config/static-2.49979",
      "tinymce-copilot": "/tinymce-copilot/static-1.12047",
      "tinymce-data": "/tinymce-data/static-1.36064",
      "tinymce-plugins": "/tinymce-plugins/static-1.53093",
      "tinymce-themes": "/tinymce-themes/static-1.51949",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8797",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9868",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9770",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7740",
      "ui-addon-opt": "/ui-addon-opt/static-4.7479",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4061",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16086",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.7729",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9091",
      "ui-product-approvals": "/ui-product-approvals/static-1.24018",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.8913",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5269",
      "UIComponents": "/UIComponents/static-3.7295",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3399",
      "usage-tracker": "/usage-tracker/static-1.6323",
      "usage-tracker-core": "/usage-tracker-core/static-1.6173",
      "user-context": "/user-context/static-1.4024",
      "video-embed": "/video-embed/static-1.30622",
      "web-interactives-components": "/web-interactives-components/static-1.11588",
      "web-interactives-data": "/web-interactives-data/static-1.11589",
      "wootric-nps": "/wootric-nps/static-1.5773",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.6046",
      "codemirror": "/codemirror/static-5.72",
      "react-codemirror": "/react-codemirror/static-1.9460",
      "enviro": "/enviro/static-4.306",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
      "raven-hubspot": "/raven-hubspot/static-1.5125",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.8459",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2491",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.8674",
      "chatspot-core": "/chatspot-core/static-1.15867",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.15861",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5721",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6718",
      "graphql": "/graphql/static-1.59",
      "magpie-lib": "/magpie-lib/static-1.4516",
      "magpie-types": "/magpie-types/static-1.3976",
      "quartz-core": "/quartz-core/static-1.4823",
      "simple-logging-lib": "/simple-logging-lib/static-1.1886",
      "ts-schema": "/ts-schema/static-1.3170",
      "cms-field-types": "/cms-field-types/static-1.3638",
      "content-embed-lib": "/content-embed-lib/static-1.6203",
      "ExportDialog": "/ExportDialog/static-6.9232",
      "forms-utils-lib": "/forms-utils-lib/static-1.10297",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.8196",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.9648",
      "react-dnd-compat": "/react-dnd-compat/static-1.3504",
      "usage-tracker-container": "/usage-tracker-container/static-1.6313",
      "video-data-lib": "/video-data-lib/static-1.29781",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.5017",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7155",
      "FireAlarmUi": "/FireAlarmUi/static-1.3670",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3674",
      "layout-dnd-components": "/layout-dnd-components/static-1.10781",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1458",
      "smart-content-core": "/smart-content-core/static-1.37714",
      "social-composer-lib": "/social-composer-lib/static-1.53645",
      "structured-content-lib": "/structured-content-lib/static-1.20625",
      "timezone-utils": "/timezone-utils/static-2.4090",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.32538",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.7618",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.9137",
      "ui-tool-access": "/ui-tool-access/static-1.8904",
      "content-icons-ui": "/content-icons-ui/static-1.1911",
      "react-aria": "/react-aria/static-1.39",
      "FileManagerImages": "/FileManagerImages/static-1.32016",
      "hs-story-utils": "/hs-story-utils/static-1.8238",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2325",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.886",
      "framer-motion": "/framer-motion/static-1.41",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "HeadJS": "/HeadJS/static-2.577",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1968",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.198",
      "moment-timezone": "/moment-timezone/static-5.51",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8260",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.913",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.23221",
      "jasmine": "/jasmine/static-4.3192",
      "marketplace-embed": "/marketplace-embed/static-1.16965",
      "quartz-core-utils": "/quartz-core-utils/static-1.2471",
      "flux-actions": "/flux-actions/static-1.273",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9320",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3541",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3628",
      "content-media-compositions": "/content-media-compositions/static-2.10521",
      "idb-keyval": "/idb-keyval/static-1.21",
      "immerable": "/immerable/static-1.2998",
      "video-components": "/video-components/static-1.8133",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.2154",
      "sassPrefix": "/sassPrefix/static-1.131",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.5538",
      "attribution-lib": "/attribution-lib/static-1.37922",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.8318",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3162",
      "reporting-ui-components": "/reporting-ui-components/static-2.59239",
      "ai-rendering-library": "/ai-rendering-library/static-1.5374",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.9048",
      "avatar-components": "/avatar-components/static-1.1287",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.18063",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.51882",
      "commerce-products-lib": "/commerce-products-lib/static-1.5156",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2955",
      "crm-links": "/crm-links/static-1.4957",
      "crm-message-bus": "/crm-message-bus/static-1.37092",
      "external-options-client-types": "/external-options-client-types/static-1.3119",
      "google-libphonenumber": "/google-libphonenumber/static-1.12",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2824",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2965",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3248",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2918",
      "smart-property-lib": "/smart-property-lib/static-1.1065",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "audio-components": "/audio-components/static-1.4509",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.501",
      "forms-ai-lib": "/forms-ai-lib/static-1.2301",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1652",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2556",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4371",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6686",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12923",
      "growth-data-modal": "/growth-data-modal/static-1.4074",
      "navigation-components": "/navigation-components/static-1.13973",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6294",
      "ui-universal-auth": "/ui-universal-auth/static-1.7646",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.3689",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4004",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2568",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14921",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.31737",
      "crm_components": "/crm_components/static-3.86980",
      "crm_data": "/crm_data/static-4.86980",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.34178",
      "customer-data-tracking": "/customer-data-tracking/static-1.5654",
      "dispatcher": "/dispatcher/static-1.113",
      "framework-data-table": "/framework-data-table/static-2.8752",
      "property-description-translator": "/property-description-translator/static-1.2699",
      "csstype": "/csstype/static-1.38",
      "batch-promise": "/batch-promise/static-1.438",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.6867",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3619",
      "navigation-messaging": "/navigation-messaging/static-1.3300",
      "feature-store-service-types": "/feature-store-service-types/static-1.3535",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3542",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3526",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12041",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3092",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5626",
      "persist-promise": "/persist-promise/static-1.2596",
      "hub-http-janus": "/hub-http-janus/static-1.648",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7123",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.348",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11265",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17936",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5299",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.13088",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.11959",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.14552",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.4452",
      "property-management-iframe": "/property-management-iframe/static-1.8519",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.4753",
      "social-insights-client-types": "/social-insights-client-types/static-1.17908",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.3569",
      "highcharts": "/highcharts/static-8.81",
      "report-customization-components": "/report-customization-components/static-1.9039",
      "reporting-action-components": "/reporting-action-components/static-1.36584",
      "reporting-data": "/reporting-data/static-1.61962",
      "reporting-enablement": "/reporting-enablement/static-1.17450",
      "reporting-snowflake": "/reporting-snowflake/static-1.50583",
      "reporting-visualizations": "/reporting-visualizations/static-1.54039",
      "customer-data-filters": "/customer-data-filters/static-1.47993",
      "reporting-plugins": "/reporting-plugins/static-1.7065",
      "reporting-reports": "/reporting-reports/static-1.61645",
      "highlight.js": "/highlight.js/static-1.45",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "ui-addon-teams": "/ui-addon-teams/static-1.19852",
      "calling-internal-common": "/calling-internal-common/static-1.30083",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.9924",
      "calling-global-api": "/calling-global-api/static-1.58205",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.59587",
      "products-iframe-lib": "/products-iframe-lib/static-1.3399",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7508",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.4256",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4091",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.7209",
      "fsm": "/fsm/static-1.2553",
      "policy-lib": "/policy-lib/static-1.5629",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.7271",
      "final-form": "/final-form/static-1.40",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1798",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.15043",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.6655",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6233",
      "crm_universal": "/crm_universal/static-1.20605",
      "customer-data-content": "/customer-data-content/static-1.24615",
      "crm_schema": "/crm_schema/static-3.87018",
      "customer-data-email": "/customer-data-email/static-1.15859",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.16611",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.6060",
      "customer-data-rte": "/customer-data-rte/static-1.29242",
      "cv-backend-services": "/cv-backend-services/static-1.1177",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4076",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13896",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.44",
      "quotes-client-types": "/quotes-client-types/static-1.32082",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6729",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.5328",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9020",
      "immutable-less": "/immutable-less/static-1.3402",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6842",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3003",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5977",
      "react-window": "/react-window/static-1.13",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8456",
      "ai-studio-lib": "/ai-studio-lib/static-1.5950",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.10388",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.14511",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.8726",
      "property-management-common": "/property-management-common/static-1.805",
      "trellis-story-utils": "/trellis-story-utils/static-1.3395",
      "dashboard-lib": "/dashboard-lib/static-1.76180",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7514",
      "reporting-client-types": "/reporting-client-types/static-1.1932",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.8384",
      "html-to-image": "/html-to-image/static-1.30",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.7964",
      "crm-object-map": "/crm-object-map/static-1.2076",
      "deep-diff": "/deep-diff/static-1.5",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.3372",
      "calling-error-reporting": "/calling-error-reporting/static-1.30089",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5342",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.30352",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.2809",
      "sales-views-client-types": "/sales-views-client-types/static-1.3162",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2792",
      "storybook-react": "/storybook-react/static-1.4",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4009",
      "utility-belt": "/utility-belt/static-1.1408",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.38425",
      "zustand": "/zustand/static-1.51",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.7186",
      "sequences-lib": "/sequences-lib/static-1.5999",
      "draft-content-plugins": "/draft-content-plugins/static-1.24603",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.19362",
      "knowledge-content-types": "/knowledge-content-types/static-1.7755",
      "stripe-connect-js": "/stripe-connect-js/static-1.40",
      "apps-service-types": "/apps-service-types/static-1.2938",
      "oauth-service-types": "/oauth-service-types/static-1.3150",
      "automation-ui-action-features": "/automation-ui-action-features/static-1.50069",
      "academy-common-lib": "/academy-common-lib/static-1.9848",
      "crm-component-utils": "/crm-component-utils/static-1.34805",
      "redux-actions": "/redux-actions/static-3.7",
      "crm-index-visualization-object-layout": "/crm-index-visualization-object-layout/static-1.822",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.6430",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.30577",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.33",
      "crm-actions": "/crm-actions/static-1.4930",
      "crm-fe-perf": "/crm-fe-perf/static-1.21852",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3205",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5856",
      "ads-client-types": "/ads-client-types/static-1.17335",
      "app-users-service-types": "/app-users-service-types/static-1.3400",
      "automation-actions-service-types": "/automation-actions-service-types/static-1.3352",
      "automation-applications-service-types": "/automation-applications-service-types/static-1.2571",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2140",
      "automation-ui-action-fields": "/automation-ui-action-fields/static-1.33374",
      "automation-ui-associations": "/automation-ui-associations/static-1.14959",
      "automation-ui-core": "/automation-ui-core/static-2.16285",
      "automation-ui-enrollment": "/automation-ui-enrollment/static-1.51716",
      "automation-ui-flow-core": "/automation-ui-flow-core/static-1.15674",
      "automation-ui-formula-editor": "/automation-ui-formula-editor/static-1.11822",
      "automation-ui-i18n": "/automation-ui-i18n/static-1.15742",
      "automation-ui-permissions": "/automation-ui-permissions/static-1.14645",
      "automation-ui-references": "/automation-ui-references/static-1.15697",
      "automation-ui-routing": "/automation-ui-routing/static-1.15709",
      "automation-ui-source-apps": "/automation-ui-source-apps/static-1.13431",
      "automation-ui-types": "/automation-ui-types/static-1.14349",
      "automation-ui-ubb": "/automation-ui-ubb/static-1.268",
      "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.15751",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.4517",
      "messaging-editing-lib": "/messaging-editing-lib/static-1.40989",
      "routing-ui": "/routing-ui/static-1.16437",
      "skills-lib": "/skills-lib/static-1.25245",
      "task-forms-lib": "/task-forms-lib/static-1.36418",
      "ui-addon-automation-embed": "/ui-addon-automation-embed/static-1.12396",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.4091",
      "academy-service-client": "/academy-service-client/static-1.2688",
      "card-properties-lib": "/card-properties-lib/static-1.39140",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.6453",
      "crm-association-components-lib": "/crm-association-components-lib/static-1.5216",
      "messaging-publishing-lib": "/messaging-publishing-lib/static-1.40941",
      "mobile-messaging-management-lib": "/mobile-messaging-management-lib/static-1.29631",
      "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2732",
      "data-ops-fullstory": "/data-ops-fullstory/static-1.4188",
      "workflows-copilot-service-types": "/workflows-copilot-service-types/static-1.1519",
      "messaging-types-lib": "/messaging-types-lib/static-1.40725",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2933",
      "ably": "/ably/static-1.18",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3425",
      "conversations-http": "/conversations-http/static-1.3650",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11499",
      "conversations-message-history": "/conversations-message-history/static-1.9953",
      "conversations-prop-types": "/conversations-prop-types/static-1.6267",
      "conversations-async-data": "/conversations-async-data/static-2.6516",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7793",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7787",
      "conversations-thread-data": "/conversations-thread-data/static-1.63108",
      "conversations-thread-view": "/conversations-thread-view/static-1.71839",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4604",
      "svh-tickets-lib": "/svh-tickets-lib/static-1.14182",
      "crm-activity-creator-data": "/crm-activity-creator-data/static-1.41514",
      "customer-data-communicator": "/customer-data-communicator/static-1.40515",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.11014",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.41356",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.10185",
      "framework-listing-lib": "/framework-listing-lib/static-2.22976",
      "industries-core": "/industries-core/static-1.5618",
      "messaging-management-lib": "/messaging-management-lib/static-1.12501",
      "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.18060",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14852",
      "conversations-routing-lib": "/conversations-routing-lib/static-1.6740",
      "call-widget-addon": "/call-widget-addon/static-2.28312",
      "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.17974",
      "calling-integration-help-desk": "/calling-integration-help-desk/static-1.19780",
      "calling-ui-library": "/calling-ui-library/static-1.65505",
      "composer-data": "/composer-data/static-1.25895",
      "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.30321",
      "conversations-platform": "/conversations-platform/static-1.3339",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.20846",
      "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5860",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.7454",
      "universal-associations-select": "/universal-associations-select/static-1.9644",
      "crm-display-components": "/crm-display-components/static-1.20555",
      "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22645",
      "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.20534",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.20282",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.13888",
      "integration-settings-components": "/integration-settings-components/static-1.10702",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.3097",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2829",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.32207",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.34160",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.49784",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.17414",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.13441",
      "project-storage": "/project-storage/static-1.3535",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.65999",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4134",
      "customer-data-views-management": "/customer-data-views-management/static-1.22430",
      "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.10224",
      "calling-client-interface": "/calling-client-interface/static-1.70744",
      "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.26200",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4979",
      "worker-connection-library": "/worker-connection-library/static-1.12361",
      "share-transcript-modal": "/share-transcript-modal/static-1.52755",
      "transcript-sidebar": "/transcript-sidebar/static-1.63109",
      "twilio-voice-sdk": "/twilio-voice-sdk/static-1.51",
      "conversations-calling-message": "/conversations-calling-message/static-1.55285",
      "signup-constants": "/signup-constants/static-1.16368",
      "signup-ui-lego-core": "/signup-ui-lego-core/static-1.18378",
      "viral-links-lib": "/viral-links-lib/static-1.5733",
      "remote-ui": "/remote-ui/static-1.40",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.12817",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4969",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.51858",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.49800",
      "SafeStorage": "/SafeStorage/static-1.3256",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.96670",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.74713",
      "crm-export-dialog": "/crm-export-dialog/static-1.5137",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.5257",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4516",
      "recording-review-components-lib": "/recording-review-components-lib/static-1.27038",
      "call-summary": "/call-summary/static-1.32897",
      "emoji-regex": "/emoji-regex/static-1.7",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6908",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.6406"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};